export default "__VITE_ASSET__BMeYqNqm__"